
import {defineComponent, ref} from 'vue'
import rem from '@/utils/rem.js'
import {useRouter} from 'vue-router'
import commonApiUtil from "@/utils/commonApiUtil";


rem(750, 750)
export default defineComponent({
  name: 'ServiceList',
  setup() {
    const router = useRouter()
    let serviceGroup = ref([])
    let isShow = ref(false)

    const init = async () => {
      const res = await commonApiUtil.apiUtilGetUrl('/api/healthc/product/listProductHnpw')
      console.log(res.code)
      if (res.code === 0) {
        if(res.data && res.data.lspphealthProductDTOList){
          serviceGroup.value.push({name: '连锁品牌', list: res.data.lspphealthProductDTOList})
        }
        if(res.data && res.data.glyyhealthProductDTOList){
          serviceGroup.value.push({name: '公立医院', list: res.data.glyyhealthProductDTOList})
        }
        isShow.value = true
      } else if (res.code === 1001) {
        await router.push('/pingweiService/userLogin')
      }
    }

    init()

    const gotoService = (item) => {
      location.href = item.productDetailUrl
    }
    const gotoOrderList = async () => {
      const res = await commonApiUtil.apiUtilGetUrl('/api/healthc/orderMater/getHealthOrderUrl?code=JKFWORDER')
      if (res.code === 0) {
        location.href = res.data.healthOrderUrl
      } else if (res.code === 1001) {
        await router.push('/pingweiService/userLogin')
      }
    }

    return {
      isShow,
      serviceGroup,
      gotoService,
      gotoOrderList
    }
  }
})
